import { Box, Grid2, Typography, Divider } from "@mui/material";
import dayjs from "dayjs";

const DetailItem = ({ label, value }) => (
    <Box display="flex" flexDirection="column" gap={0.5}>
        <Typography variant="caption" color="secondary.main" fontWeight={500}>
            {label}
        </Typography>
        <Typography variant="body2" fontWeight={600} color="text.primary">
            {value}
        </Typography>
    </Box>
);

const SchoolDetails = ({ school }) => {

    const formatDate = (date) => {
        if (!date) return "-";
        return dayjs(date).format("DD-MM-YYYY");
    };

    const formatCurrency = (val) => {
        if (!val) return "-";
        return Number(val).toLocaleString("en-IN");
    };

    return (
        <Box
            sx={{
                p: 3,
                bgcolor: "#fafafa",
                borderRadius: 2,
                border: "1px solid",
                borderColor: "grey.200",
                boxShadow: "0 2px 4px rgba(0,0,0,0.02)"
            }}
        >
            <Grid2 container spacing={3}>
                <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                    <DetailItem label="School Type" value={school.school_type || "-"} />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                    <DetailItem label="Date Of Establishment" value={formatDate(school.date_of_establishment)} />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                    <DetailItem label="Board" value={school.board || "-"} />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                    <DetailItem label="Students No" value={school.no_of_students ?? "-"} />
                </Grid2>

                <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                    <DetailItem label="Publications" value={school.publication || "-"} />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                    <DetailItem label="Quantity" value={school.quantity ?? "-"} />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                    <DetailItem label="Faculty" value={school.faculty || "-"} />
                </Grid2>
                
                <Grid2 size={12}>
                    <Divider sx={{ my: 1, borderColor: "grey.200" }} />
                </Grid2>

                <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                    <DetailItem label="Country" value={school.country_name || "-"} />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                    <DetailItem label="State" value={school.state_name || "-"} />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                    <DetailItem label="City" value={school.city_name || "-"} />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                    <DetailItem label="Pincode" value={school.pincode || "-"} />
                </Grid2>
                
                <Grid2 size={12}>
                    <Divider sx={{ my: 1, borderColor: "grey.200" }} />
                </Grid2>

                <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                    <DetailItem label="Fees" value={school.fees ? `₹ ${formatCurrency(school.fees)}` : "-"} />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
                    <DetailItem label="Avg Fees" value={school.avg_fee ? `₹ ${formatCurrency(school.avg_fee)}` : "-"} />
                </Grid2>
            </Grid2>
        </Box>
    );
};

export default SchoolDetails;
